export const INVOICE_PLAN_SYSCODE = {
  Reserved: 0,
  Sandbox: 1,
  Staging: 2,
  Production: 3
};

export const InvoicePlanSyscodeString = {
  [INVOICE_PLAN_SYSCODE.Reserved]: "Reserved",
  [INVOICE_PLAN_SYSCODE.Sandbox]: "Sandbox",
  [INVOICE_PLAN_SYSCODE.Staging]: "Staging",
  [INVOICE_PLAN_SYSCODE.Production]: "Production",
};